export const modalStyles = {
  overlay: {
    zIndex: 200,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
  },
};

export const emailSharingTypes = {
  EMAIL: 'email',
  DOWNLOAD: 'download',
};

export const VTO_IFRAME_BUTTONS_SHIFT = 0;
